export default __webpack_public_path__ + "static/media/heroImgMizata.8ae6e5bd.jpg";